import { Helmet } from "react-helmet-async";

const SITE_URL = "https://d365.universeit.com";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "UniverseIT",
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.png`,
  description: "UniverseIT delivers Microsoft Dynamics 365 CRM (Sales & Customer Service), Business Central ERP, D365 add-ons, and full D365 implementation services.",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1-833-447-3848",
    contactType: "customer service",
    areaServed: "US",
    availableLanguage: "English"
  },
  sameAs: [
    "https://www.linkedin.com/company/universeit"
  ]
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#localbusiness`,
  name: "UniverseIT",
  image: `${SITE_URL}/favicon.png`,
  url: SITE_URL,
  telephone: "+1-833-447-3848",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "10670 N Central Expressway, Suite 420",
    addressLocality: "Dallas",
    addressRegion: "TX",
    postalCode: "75231",
    addressCountry: "US"
  },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "17:00"
  },
  description: "UniverseIT provides Microsoft Dynamics 365 CRM, Business Central ERP, D365 add-ons and full-service D365 implementations.",
  areaServed: {
    "@type": "Country",
    name: "United States"
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "UniverseIT — Dynamics 365",
  description: "Microsoft Dynamics 365 CRM, ERP & implementation services from UniverseIT.",
  publisher: {
    "@id": `${SITE_URL}/#organization`
  }
};

const OrganizationSchema = () => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;
